export default "__VITE_ASSET__BG3u14V1__"